export class CsvReader {
  public read(blob: Blob, config: Partial<CsvReaderConfig> = {}): Promise<string[][]> {
    const _config: CsvReaderConfig = {
      separator: ',',
      encoding: 'UTF-8',
      ...config
    }

    return new Promise<string[][]>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(this.split(reader.result as string, _config));
      reader.onerror = () => reject();
      reader.readAsText(blob, _config.encoding);
    });
  }

  private split(text: string, config: CsvReaderConfig): string[][] {
    const result: string[][] = [];
    const rx = new RegExp('("(?:[^"]|"")*"|.*?)(' + config.separator + '|\r\n|\r|\n|$)', 'g');

    let match, fields: string[] = [];
    while ((match = rx.exec(text)) != null) {
      const field = match[1].replace(/"((?:[^"]|"")*)"/, '$1').replace(/""/g, '"');
      const separator = match[2];

      fields.push(field);
      if (/^(?:|\r\n|\r|\n)$/g.test(separator)) {
        if (fields.length && fields[0]) {
          result.push(fields);
        }
        fields = [];
      }

      if (separator === '') {
        break;
      }
    }
    return result;
  }
}

export type CsvReaderConfig = {
  separator: string;
  encoding: string;
}
